import { createFileRoute } from '@tanstack/react-router'
import { RealEstateContactsTab } from '~/components/routes/development/real-estate/contacts/real-estate-contacts-tab'
import { CONTACT_READ, realEstateTabGuard } from '~/components/routes/development/real-estate/tabs'

export const Route = createFileRoute('/_authenticated/development/real-estate/contacts')({
  staticData: { permission: CONTACT_READ },
  beforeLoad: realEstateTabGuard('contacts'),
  component: RealEstateContactsTab,
})
